import { ApolloClient, gql, useApolloClient, useLazyQuery } from '@apollo/client';
import { InsightsResponse } from '../Constants/insightTypes';

export interface GetInsightsVars {
    entityType: String;
    entityValue: String;
    startTime: number;
    endTime: number;
    filters?: string;
}

const GET_INSIGHTS = gql`
    query GetInsights(
            $entityType: String,
            $entityValue: String,
            $startTime: Float,
            $endTime: Float,
            $filters: String,
        ){
        getInsights(
            entityType: $entityType,
            entityValue: $entityValue,
            startTime: $startTime,
            endTime: $endTime,
            filters: $filters,
        )
    }
`;

export const useGetInsightsQuery = () => {
    return useLazyQuery<InsightsResponse, GetInsightsVars>(GET_INSIGHTS, {
        errorPolicy: 'all',
        fetchPolicy: 'network-only'
    });
};

export async function fetchDomainInsights(
  client: ApolloClient<object>,
  domainIdent: string,
  dateRange,
  filters = undefined,
): Promise<InsightsResponse> {
  const { data } = await client.query<any, GetInsightsVars>({
    query: GET_INSIGHTS,
    variables: {
      entityType: 'DOMAINIDENT',
      entityValue: domainIdent,
      startTime: dateRange.from,
      endTime: dateRange.to,
      filters: filters ? JSON.stringify(filters) : undefined,
    },
    fetchPolicy: 'network-only',
  });
  return data?.getInsights?.record?.insights || [];
}
